import { serializeObject } from "../common/helper";
import { Request } from "./HttpService";

export const UserService = {
  getAll: function (pageSize, pageNumber) {
    return Request(`userAccess/user/${pageSize}/${pageNumber}`, "GET");
  },

  getAllSupervisors: function () {
    return Request(`userAccess/user/Supervisor`, "GET");
  },

  getById: function (userId) {
    return Request("userAccess/user/" + userId, "GET");
  },

  getAllUsers: function (pageSize, pageNumber, searchObject) {
    let url = `userAccess/user/${pageSize}/${pageNumber}`;
    let keys = Object.keys(searchObject);
    if (keys.length > 0) {
      url = url + "?";
      url = url + serializeObject(searchObject);
    }
    return Request(url, "GET");
  },

  createOrUpdate: function (user) {
    let _user = {
      ...user,
      companyRoles: user.companyRoles.map((x) => x.id),
      roles: user.roles.map((x) => x.id)
    };

    return Request("userAccess/user", user.id ? "PUT" : "POST", _user);
  },

  getRoles: function () {
    return Request("userAccess/role", "GET");
  },
  getManagersToRecommend: function (companyId) {
    return Request(`userAccess/user/managersToRecommend/${companyId}`, "GET");
  },
  getHRToRecommend: function (companyId) {
    return Request(`userAccess/user/HRToRecommend/${companyId}`, "GET");
  },
  getSuperVisorList: function () {
    return Request("userAccess/user/All", "GET");
  }
};
